import React from "react";
import {CustomCard, ImageGroup, LabelGroup} from "../index";
import './styles.scss'

const ListCard=({title,description})=>{
  return(
    <CustomCard>
      <LabelGroup title={title} description={description}/>
      <div className="list-card">
        <div className="d-flex">
          <ImageGroup title='design team' xs={true}/>
        </div>
        <div className="card-item mt-4">
          <div className="card-item-body">
            <div className="card-item-stat">
              <small className="tx-10 text-primary font-weight-semibold">25 August 2020</small>
              <h6 className=" mt-2">Mobile app design</h6>
            </div>
          </div>
        </div>
      </div>
    </CustomCard>
  )
}
export default ListCard;
